import LoyaltyCards from "@/models/loyaltyPanel/LoyaltyCards";

export default {
    namespaced: true,

    state: () => ({
        loyaltyCards: [],
        loyaltyCard: new LoyaltyCards(),
        exportedFile: null
    }),

    mutations: {
        setLoyaltyCards(state, payload) {
            state.loyaltyCards = payload;
        },

        setLoyaltyCard(state, payload) {
            state.loyaltyCard = new LoyaltyCards(payload);
        },

        setExportedFile(state, payload) {
            state.exportedFile =payload;
        }
    },

    actions: {
        async fetchLoyaltyCards({ commit }, body) {
            try {
                commit("setLoading", true, { root: true });

                let filter = ""
                Object.keys(body.filters).map((key) => {
                    if(body.filters[key]){
                        filter += "&" + key + "=" + body.filters[key]   
                    }
                })

                const { data } = await LoyaltyCards.get(body.query,filter);
                const { loyalty_cards, pagination } = data.data;
                commit("setLoyaltyCards", loyalty_cards);
                commit("setServerItemsLength", pagination.total, {
                    root: true
                });
                commit("setServerPagination", pagination, {
                    root: true
                });
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async createOrder({ commit, dispatch, state }) {
            try {
                commit("setLoading", true, { root: true });

                await LoyaltyCards.create(state.loyaltyCard);

                dispatch("fetchLoyaltyCards","?page=1");
                commit("setDialog", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully created new order!"
                    },
                    {root: true}
                );
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },
                    {root: true}
                );
            }
        },

        async remove({ commit, dispatch }, id) {
            try {
                commit("setLoading", true, { root: true });

                await LoyaltyCards.delete(id);

                dispatch("fetchPointTitles");
                
                commit("setDeleteDialog", false, { root: true });
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "The Point Title is successfully deleted!"
                    },
                    {root: true}
                );
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },
        async getExportedFile({ commit }) {
            try {
                const data = await LoyaltyCards.getExportedFile()
                commit("setExportedFile", data.data.data)
            } catch (ex) {
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },
        
        async exportFile({ commit }, body) {
            try {
                commit("setLoading", true, { root: true });

                const data = await LoyaltyCards.exportFile(body)
                commit("setExportedFile", data.data.data)

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },

        async deleteExportedFile({ commit }, id) {
            try {
                commit("setLoading", true, { root: true });

                await LoyaltyCards.deleteExportedFile(id)
                commit("setExportedFile", null)

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        }
    }
};
